    
    import Dialog from '@mui/material/Dialog';
    import DialogActions from '@mui/material/DialogActions';
    import DialogContent from '@mui/material/DialogContent';
    import DialogContentText from '@mui/material/DialogContentText';
    import DialogTitle from '@mui/material/DialogTitle';
    import React, { useState,useEffect} from 'react';
   import Helper from './Helper';
   import AxiosFetchData from './AxiosFetchData';
   import Box from '@mui/material/Box';
   import {  useNavigate } from 'react-router-dom';
   import axios from 'axios';
   import {apiUrl} from './UrlParam'; 
   import VirtualizedSelect from 'react-virtualized-select';
    export default function ApprovalDetailDialog({approvalopen, approvalclose, data, projectId}) {
        
        const [rows, setRows] =  useState([]);
        const navigate = useNavigate();
        const [totalPo, setTotalPo] =  useState(0);
        const [code, setCode] =  useState([]);
        const [unitList, setUnitList] = useState([]);

        useEffect(() => {
            //alert(productopen)
         
            if(approvalopen) {
              //  approvalclose(true);
                GetData();
                axios.get(`${apiUrl}/api/GetUnits`)
                .then((response) => {
                  const transformedOptions = response.data.map((item) => ({
                    label: `${item.name}`,
                    value: item.id,
                  }));
                  setUnitList(transformedOptions);
                
                })
                .catch((error) => {
                  console.error('Error fetching category data:', error);
                });
               
               
              
            }
          
        }, [approvalopen]);

        const handleClose = () => {
            approvalclose(false)
        }

        const GetData = async () => {
            
            try{
                const response = await AxiosFetchData.get(`GetQuotationById/${projectId}/rak`).refreshToken(navigate,"approval");
              //  console.log(response.data)
                setRows(data);
                GetCodeList(response.data);
              
               // console.log(data)
            }catch(e){ 
               console.error(e);
            }
        };

        function GetTotal1(){
            var  total = 0;
            
             if(approvalopen){
             
                for(let i=0; i < data.newdata.length; i++){
                    total += data.newdata[i].total1
                   }
             }
          
             return total;
        }

        function GetTotal2(){
            var  total = 0;
            
             if(approvalopen){
           
                for(let i=0; i < data.olddata.length; i++){
                    total += data.olddata[i].total1
                   }
             }
          
             return total;
        }

        const GetCodeList = (response) => {
          
            var code = response;
            //var code = response.data.rak;
             var temp= [];
             var totalPo = 0;
             for(var i=0; i < code.length; i++) {
                 if(temp.findIndex((x) =>x.code == code[i].code)  == -1) {
                   var data ={
                      code : code[i].code,
                      total_project : code[i].totalpo
                   }
                   //  temp.push(code[i]);
                   totalPo += code[i].totalpo;
                   temp.push(data);
                 }
             }
             setTotalPo(totalPo) ;
             setCode(temp.sort());
           }
         
         
          
          function calcHeight2(value) {
             
            let numberOfLineBreaks = (value.match(/\n/g) || []).length;
             // min-height + lines x line-height + padding + border
            let newHeight =  numberOfLineBreaks  
            
            return newHeight;
          }

          function GetTotal3(){
            var  total = 0;
           
            if(approvalopen){
                for(let i=0; i < data.newrealisasi.length; i++){
                    if(data.newrealisasi[i].tipe == 'debit'){
                      total += parseFloat(data.newrealisasi[i].debit)
                    }
                   
                    if(data.newrealisasi[i].tipe == 'credit'){
                      total -= parseFloat(data.newrealisasi[i].credit)
                    }
                  }

            }
         
             
            return total;
          }

          function GetTotal4(){
            var  total = 0;
           
            if(approvalopen){
                for(let i=0; i < data.oldrealisasi.length; i++){
                    if(data.oldrealisasi[i].tipe == 'debit'){
                      total += parseFloat(data.oldrealisasi[i].debit)
                    }
                   
                    if(data.oldrealisasi[i].tipe == 'credit'){
                      total -= parseFloat(data.oldrealisasi[i].credit)
                    }
                  }

            }
         
             
            return total;
          }
          
        return( 
            <Dialog
                open={approvalopen}
                onClose={handleClose}
                maxWidth="md"
            >
                <form  role="form"> 
                <DialogTitle><h4>APPROVAL DETAIL</h4></DialogTitle>
                <DialogContent>
                    <DialogContentText>
                    {(approvalopen && data.olddata.length  > 0) && (
                      <b><h5>CURRENT DATA</h5></b>
                   
                    )}
                     </DialogContentText>
                     <>
                    <table width={"100%"} border={0} id="tblRAK"  cellSpacing={0} cellPadding={0} >
      <tr>
            <td>
              <Box sx={{boxShadow:5}} >
                {(approvalopen && data.olddata.length  > 0) && (
              <table border={1} style={{width:"100%",fontSize:10,borderColor:"gray"}} cellSpacing={0} cellPadding={0}  id="table1" >
                <tr style={{backgroundColor:"#f4f4f4"}}>
                    <td colSpan={7} style={{textAlign:"center", fontWeight:"bold", backgroundColor:"gray", color:"white", fontSize:14}}>BUDGET PLAN</td>
                     
                    
                </tr>
                <tr>
                   
                    <td style={{width:10, fontWeight:"bold", paddingLeft:5, paddingRight:5}}>No</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Description</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Qty</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Unit</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>HPP</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Total</td>
                   
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Type</td>
                </tr>
                {code.map((product2, index2) => (
                    //   return (
                   <>
                     <tr>
                         <td colSpan="7" >
                             <table width={"100%"} cellPadding={0} cellSpacing={0} border={0}>
                                 <tr style={{height:20,padding:5}}>
                                    
                                     <td style={{height:20,padding:5}}  ><b>#{product2.code}{product2.code.includes("-") ? " (Additional Work)" : ''}</b></td>
                                     <td style={{height:20,padding:5, textAlign:"right"}}  ><b>  PROJECT VALUE :</b></td>
                                     <td style={{height:20,padding:5, textAlign:"left"}} width={60}><b>{Helper.formatAsCurrency(product2.total_project)}</b></td>
                                 </tr>
                             </table>
                        </td>
                     </tr>
                     {rows.olddata.filter((item) => item.code == product2.code).map((product, index) => (
                           
                              <tr id={"tr" + index} className='tableTr' key={"key"+index}>
                             
                             <td style={{textAlign:"center"}}>{index + 1} </td>
                             <td style={{width:200}}>  <textarea
                              type="text"
                              className="form-control resize-ta"
                              placeholder="Description"
                              value={product.descriptions}
                              id={product2.code + index}
                              rows={calcHeight2(product.descriptions)}
                              style={{ fontSize:10, borderWidth:0, overflow:'hidden',resize:'both', width:'100%',display:'block'}}
                              disabled={true}
                            /></td>
                              <td style={{width:70}}>  <input
                             // type="text"
                              className="form-control"
                              placeholder="Qty"
                              value={product.qty1}
                              id={index}
                              type="number"
                              min ={0}
                              style={{fontSize:11,borderWidth:0}}
                              required
                              disabled={true}
                              
                            /></td>
                            <td style={{textAlign: "center", fontSize:12, verticalAlign:"top", width:80}}>
                            {/* <input
                              type="text"
                              className="form-control"
                              placeholder="Unit"
                              value={product.unit1_name}
                              id={index}
                             
                              style={{fontSize:11, borderWidth:0}}
                              required
                              disabled={true}
                             
                            /> */}
                             <VirtualizedSelect
                                options={unitList}
                               // onChange={(option) => handleSelectedUnit(option.value, product.id )}
                                value={product.unit_id}
                                clearable={false}
                                searchable={true}
                                
                                style={{fontSize:10, borderWidth:0}}
                                required
                                
                            /> 
                            {/* {product.name} */}
                            </td>
                            <td style={{width:120}}>  <input
                              type="text"
                              className="form-control"
                              placeholder="Hpp"
                              value={Helper.formatAsCurrency(product.hpp1)}
                             // value={product.hpp1}
                              id={index}
                             // min={0}
                              style={{fontSize:11, borderWidth:0}}
                              required
                              disabled={true}
                             
                            /></td>
                             <td  style={{width:100}}>  <input
                              type="text"
                              className="form-control"
                              placeholder="Total"
                              value={Helper.formatAsCurrency(product.total1)}
                              id={index}
                              style={{fontSize:11,borderWidth:0}}
                              required
                              readOnly
                             
                            /></td>
                            <td  style={{width:100}}>  <input
                              type="text"
                              className="form-control"
                              placeholder="Total"
                              value={product.product_type == null ? "-" : (product.product_type == 1 ? "Item" : "Service")}
                              id={index}
                              style={{fontSize:11,borderWidth:0}}
                              required
                              readOnly
                             
                            /></td>
                          </tr>
                           // );
                          ))}
                      
                      </>
                ))}

                
  
<tr style={{backgroundColor:"#f4f4f4"}}>
      <td colspan="6" align='right' style={{fontSize:12,paddingRight:5}}><b>TOTAL COST</b></td>
      <td style={{fontSize:12,paddingLeft:5}}>{Helper.formatAsCurrency(GetTotal2())}</td>
      
    </tr>
    
     <tr style={{backgroundColor:"#f4f4f4"}}>
      <td colspan="6" align='right' style={{fontSize:12,paddingRight:5}}>Margin</td>
      <td style={{fontSize:12,paddingLeft:5}}>{Helper.formatAsCurrency(totalPo - GetTotal2())}</td>
     
    </tr>  
    
    
     <tr style={{backgroundColor:"#f4f4f4"}}>
      <td colspan="6" align='right' style={{fontSize:12,paddingRight:5}}>Percentage</td>
      <td style={{fontSize:12,paddingLeft:5}}>{(((totalPo - GetTotal2())  / GetTotal2) * 100).toFixed(2)} %</td>
      
    </tr>  
    
    
      </table>


      
      )}
      </Box>
                
            </td>
        </tr>
         <tr>
            <td>&nbsp;</td>
         </tr>
         
    </table>
  {(approvalopen && data.oldrealisasi.length  > 0) && (
     <Box sx={{boxShadow:5}} >
    <table border={0} style={{width:"100%",fontSize:10,borderColor:"gray" }} id="tblRAK"  >
    
    <tr>
      <td colspan="5" align='right'>
        <table width="100%"  border={1} > 
        <tr>
          <td colspan="5" align='center' style={{padding:3, backgroundColor:"gray", color:"white", fontSize:14}}><b>REALIZATION</b></td>
        </tr>
                <tr style={{backgroundColor:"#f4f4f4" }}>
                    <td style={{padding:2,textAlign:"center" }}><b>No</b></td>
                    <td style={{padding:2 }}><b>RAK Implementation</b></td>
                    <td style={{padding:2 }}><b>Debit</b></td>
                    <td style={{padding:2 }}><b>Credit</b></td>
                    <td style={{padding:2 }}><b>Balance</b></td> 
                    <td></td> 
                </tr>
                {data.oldrealisasi.map((item, index) => (
                  <tr  style={{backgroundColor:"white"}}>
                    <td style={{textAlign:"center" }}>{index + 1}</td>
                    <td>
                    <textarea
                              type="text"
                              className="form-control"
                              placeholder="RAK Implementation"
                               value={item.descriptions}
                              id={index}
                              disabled={true}
                            //  rows={calcHeight2(product.descriptions)}
                              style={{ fontSize:10, borderWidth:0, overflow:'hidden',resize:'both', width:'100%',display:'block'}}
                              
                            />
                    </td>
                    <td>
                    <input
                              type="text"
                              className="form-control"
                              placeholder="Debit"
                              value={ item.debit == '' ? 0 : Helper.formatAsCurrency(item.debit) }
                              id={'txtDebit' + item.id}
                             // min={0}
                              
                              style={{fontSize:11, borderWidth:0}}
                              required
                              disabled ={true}
                             // disabled ={item.credit > 0 ? item.debit }
                              //disabled={item.debit == 0 &&  item.credit ==0 ? false : (item.debit > 0 ? false : true)}
                             
                            />
                    </td>
                    <td> <input
                              type="text"
                              className="form-control"
                              placeholder="Credit"
                              value={ item.credit == '' ? 0 : Helper.formatAsCurrency(item.credit)}
                              id={'txtCredit' + item.id}
                             // min={0}
                              style={{fontSize:11, borderWidth:0}}
                              required
                               disabled={true}
                             
                            /></td>
                    <td> <input
                              type="text"
                              className="form-control"
                              placeholder="Saldo"
                              value={item.credit == 0 &&  item.debit ==0 ? 0 : Helper.formatAsCurrency(item.saldo)}
                              id={index}
                          
                              style={{fontSize:11, borderWidth:0}}
                              required
                              disabled={true}
                             
                            /></td> 
                            
                  </tr>
                ))}
                
                
                
                <tr style={{backgroundColor:"#f4f4f4"}}>
                    <td colspan="4" align='right' style={{fontSize:12,paddingRight:5}}><b>BALANCE</b></td>
                    <td style={{fontSize:12,paddingLeft:5}}>{Helper.formatAsCurrency(GetTotal4())}</td>
                </tr>  
                <tr style={{backgroundColor:"#f4f4f4"}}>
                    <td colspan="4" align='right' style={{fontSize:12,paddingRight:5}}>Percentage</td>
                    <td style={{fontSize:12,paddingLeft:5}}>{((GetTotal4() / totalPo) * 100).toFixed(2)}</td>
                </tr> 
        </table>
      </td>
       
    </tr>
    
    {/* <tr style={{backgroundColor:"#f4f4f4"}}>
      <td colspan="7" align='right' style={{fontSize:12,paddingRight:5}}>Balance</td>
      <td style={{fontSize:12,paddingLeft:5}}>{Helper.formatAsCurrency(GetTotal3())}</td>
      <td colspan="3" align='right' style={{fontSize:12,paddingRight:5}}> &nbsp;</td>
      <td  style={{fontSize:12,paddingLeft:5}}> {Helper.formatAsCurrency(GetTotal2())}</td>
      <td colspan="2" style={{fontSize:12,paddingLeft:5}}> {(GetTotal1() - GetTotal2()) > 0 ? "SAVING" : "BOROS"} {(((GetTotal1() - GetTotal2()) / GetTotal1()) * 100).toFixed(2)} %</td>
    </tr> */}
    
    </table>
    </Box>
  )}

{(approvalopen && data.oldrealisasi.length  > 0) && (
  <hr style={{height:1,color:'black', backgroundColor:'black'}}></hr>
)}
</>
 
    <DialogContentText>
                    <b><h5>REQUESTED DATA</h5></b>
                    </DialogContentText>
                    <table width={"100%"} border={0} id="tblRAK"  cellSpacing={0} cellPadding={0} >
      <tr>
            <td>
              <Box sx={{boxShadow:5}} >
              <table border={1} style={{width:"100%",fontSize:10,borderColor:"gray"}} cellSpacing={0} cellPadding={0}  id="table1" >
                <tr style={{backgroundColor:"#f4f4f4"}}>
                    <td colSpan={7} style={{textAlign:"center", fontWeight:"bold", backgroundColor:"gray", color:"white", fontSize:14}}>BUDGET PLAN</td>
                     
                    
                </tr>
                <tr>
                   
                    <td style={{width:10, fontWeight:"bold", paddingLeft:5, paddingRight:5}}>No</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Description</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Qty</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Unit</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>HPP</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Total</td>
                   
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Type</td>
                </tr>
                {code.map((product2, index2) => (
                    //   return (
                   <>
                     <tr>
                         <td colSpan="7" >
                             <table width={"100%"} cellPadding={0} cellSpacing={0} border={0}>
                                 <tr style={{height:20,padding:5}}>
                                    
                                     <td style={{height:20,padding:5}}  ><b>#{product2.code}{product2.code.includes("-") ? " (Additional Work)" : ''}</b></td>
                                     <td style={{height:20,padding:5, textAlign:"right"}}  ><b>  PROJECT VALUE :</b></td>
                                     <td style={{height:20,padding:5, textAlign:"left"}} width={60}><b>{Helper.formatAsCurrency(product2.total_project)}</b></td>
                                 </tr>
                             </table>
                        </td>
                     </tr>
                     {rows.newdata.filter((item) => item.code == product2.code).map((product, index) => (
                           
                              <tr id={"tr" + index} className='tableTr' key={"key"+index}>
                             
                             <td style={{textAlign:"center"}}>{index + 1} </td>
                             <td style={{width:200}}>  <textarea
                              type="text"
                              className="form-control resize-ta"
                              placeholder="Description"
                              value={product.descriptions}
                              id={product2.code + index}
                              rows={calcHeight2(product.descriptions)}
                              style={{ fontSize:10, borderWidth:0, overflow:'hidden',resize:'both', width:'100%',display:'block'}}
                              disabled={true}
                            /></td>
                              <td style={{width:70}}>  <input
                             // type="text"
                              className="form-control"
                              placeholder="Qty"
                              value={product.qty1}
                              id={index}
                              type="number"
                              min ={0}
                              style={{fontSize:11,borderWidth:0}}
                              required
                              disabled={true}
                              
                            /></td>
                            <td style={{textAlign: "center", fontSize:12, verticalAlign:"top", width:80}}>
                            {/* <input
                              type="text"
                              className="form-control"
                              placeholder="Unit"
                              value={product.unit1_name}
                              id={index}
                             
                              style={{fontSize:11, borderWidth:0}}
                              required
                              disabled={true}
                             
                            /> */}
                             <VirtualizedSelect
                                options={unitList}
                               // onChange={(option) => handleSelectedUnit(option.value, product.id )}
                                value={product.unit1_id}
                                clearable={false}
                                searchable={true}
                                
                                style={{fontSize:10, borderWidth:0}}
                                required
                                disabled={true}
                            /> 
                            
                            {/* {product.name} */}
                            </td>
                            <td style={{width:120}}>  <input
                              type="text"
                              className="form-control"
                              placeholder="Hpp"
                             // value={Helper.formatAsCurrency((product.hpp1).toString())}
                              value={Helper.formatAsCurrency(product.hpp1)}
                              id={index}
                            //  min={0}
                              style={{fontSize:11, borderWidth:0}}
                              required
                              readOnly
                             
                            /></td>
                             <td  style={{width:100}}>  <input
                              type="text"
                              className="form-control"
                              placeholder="Total"
                              value={Helper.formatAsCurrency(product.total1)}
                              id={index}
                              style={{fontSize:11,borderWidth:0}}
                              required
                              readOnly
                             
                            /></td>
                             <td  style={{width:100}}>  <input
                              type="text"
                              className="form-control"
                              placeholder="Total"
                              value={product.product_type == null ? "-" : (product.product_type == 1 ? "Item" : "Service")}
                              id={index}
                              style={{fontSize:11,borderWidth:0}}
                              required
                              readOnly
                             
                            /></td>
                          </tr>
                           // );
                          ))}
                      
                      </>
                ))}

                
  
<tr style={{backgroundColor:"#f4f4f4"}}>
      <td colspan="6" align='right' style={{fontSize:12,paddingRight:5}}><b>TOTAL COST</b></td>
      <td style={{fontSize:12,paddingLeft:5}}>{Helper.formatAsCurrency(GetTotal1())}</td>
      
    </tr>
    
     <tr style={{backgroundColor:"#f4f4f4"}}>
      <td colspan="6" align='right' style={{fontSize:12,paddingRight:5}}>Margin</td>
      <td style={{fontSize:12,paddingLeft:5}}>{Helper.formatAsCurrency(totalPo - GetTotal1())}</td>
     
    </tr>  
    
    
     <tr style={{backgroundColor:"#f4f4f4"}}>
      <td colspan="6" align='right' style={{fontSize:12,paddingRight:5}}>Percentage</td>
      <td style={{fontSize:12,paddingLeft:5}}>{(((totalPo - GetTotal1())  / totalPo) * 100).toFixed(2)} %</td>
      
    </tr>  
    
    
      </table>
      </Box>
                
            </td>
        </tr>
         <tr>
            <td>&nbsp;</td>
         </tr>
         
    </table>

    {(approvalopen && data.newrealisasi.length  > 0) && (
         <Box sx={{boxShadow:5}} >
    <table border={0} style={{width:"100%",fontSize:10,borderColor:"gray" }} id="tblRAK"  >
    
    <tr>
      <td colspan="5" align='right'>
        <table width="100%"  border={1} > 
        <tr>
          <td colspan="5" align='center' style={{padding:3, backgroundColor:"gray", color:"white", fontSize:14}}><b>REALIZATION</b></td>
        </tr>
                <tr style={{backgroundColor:"#f4f4f4" }}>
                    <td style={{padding:2,textAlign:"center" }}><b>No</b></td>
                    <td style={{padding:2 }}><b>RAK Implementation</b></td>
                    <td style={{padding:2 }}><b>Debit</b></td>
                    <td style={{padding:2 }}><b>Credit</b></td>
                    <td style={{padding:2 }}><b>Balance</b></td> 
                    <td></td> 
                </tr>
                {data.newrealisasi.map((item, index) => (
                  <tr  style={{backgroundColor:"white"}}>
                    <td style={{textAlign:"center" }}>{index + 1}</td>
                    <td>
                    <textarea
                              type="text"
                              className="form-control"
                              placeholder="RAK Implementation"
                               value={item.implementasi}
                              id={index}
                              disabled={true}
                              style={{ fontSize:10, borderWidth:0, overflow:'hidden',resize:'both', width:'100%',display:'block'}}
                              
                            />
                    </td>
                    <td>
                    <input
                              type="text"
                              className="form-control"
                              placeholder="Debit"
                              value={ item.debit == '' ? 0 : Helper.formatAsCurrency(item.debit) }
                              id={'txtDebit' + item.id}
                             // min={0}
                              
                              style={{fontSize:11, borderWidth:0}}
                              required
                              disabled ={true}
                             // disabled ={item.credit > 0 ? item.debit }
                              //disabled={item.debit == 0 &&  item.credit ==0 ? false : (item.debit > 0 ? false : true)}
                             
                            />
                    </td>
                    <td> <input
                              type="text"
                              className="form-control"
                              placeholder="Credit"
                              value={ item.credit == '' ? 0 : Helper.formatAsCurrency(item.credit)}
                              id={'txtCredit' + item.id}
                             // min={0}
                              style={{fontSize:11, borderWidth:0}}
                              required
                               disabled={true}
                             
                            /></td>
                    <td> <input
                              type="text"
                              className="form-control"
                              placeholder="Saldo"
                              value={item.credit == 0 &&  item.debit ==0 ? 0 : Helper.formatAsCurrency(item.saldo)}
                              id={index}
                          
                              style={{fontSize:11, borderWidth:0}}
                              required
                              disabled={true}
                             
                            /></td> 
                            
                  </tr>
                ))}
                
                
                
                <tr style={{backgroundColor:"#f4f4f4"}}>
                    <td colspan="4" align='right' style={{fontSize:12,paddingRight:5}}><b>BALANCE</b></td>
                    <td style={{fontSize:12,paddingLeft:5}}>{Helper.formatAsCurrency(GetTotal3())}</td>
                </tr>  
                <tr style={{backgroundColor:"#f4f4f4"}}>
                    <td colspan="4" align='right' style={{fontSize:12,paddingRight:5}}>Percentage</td>
                    <td style={{fontSize:12,paddingLeft:5}}>{((GetTotal3() / totalPo) * 100).toFixed(2)}</td>
                </tr>  
        </table>
      </td>
       
    </tr>
    
    {/* <tr style={{backgroundColor:"#f4f4f4"}}>
      <td colspan="7" align='right' style={{fontSize:12,paddingRight:5}}>Balance</td>
      <td style={{fontSize:12,paddingLeft:5}}>{Helper.formatAsCurrency(GetTotal3())}</td>
      <td colspan="3" align='right' style={{fontSize:12,paddingRight:5}}> &nbsp;</td>
      <td  style={{fontSize:12,paddingLeft:5}}> {Helper.formatAsCurrency(GetTotal2())}</td>
      <td colspan="2" style={{fontSize:12,paddingLeft:5}}> {(GetTotal1() - GetTotal2()) > 0 ? "SAVING" : "BOROS"} {(((GetTotal1() - GetTotal2()) / GetTotal1()) * 100).toFixed(2)} %</td>
    </tr> */}
    
    </table>
    </Box>
  )}
                </DialogContent>
                <DialogActions>
                    <button className='btn' onClick={handleClose} type='button'>CANCEL</button>
                </DialogActions>
                </form>
                </Dialog>
            
        )
    }
    
    